// Copyright (c) 2020 WiseTime. All rights reserved.

import React from "react"
import styled, { css, SimpleInterpolation } from "styled-components/macro"
import { getDurationStr } from "../dateTime"
import { TrashStatus } from "generated/wisetime/user/timeline/v4/timeline_pb"
import { ROW_DURATION_VISIBILITY_CLASSNAME } from "features/shared/classNames"

export const DurationLabel = styled.span<{
  toggleVisibility: boolean,
  pendingStatus?: TrashStatus,
}>`
  font-size: 1.1rem;
  min-width: 6.9rem;
  padding: 1rem 1.6rem 1rem 1rem;
  text-align: right;

  ${({ pendingStatus, theme }): SimpleInterpolation => {
    if (pendingStatus === TrashStatus.TRASHED) {
      return css`
        color: ${theme.colors.lightCoral};
        text-decoration: line-through;
      `
    }
    return css`
      color: ${theme.colors.nero};
    `
  }}

  @media (min-width: ${({ theme }): string => theme.screen.md}) {
  ${({ toggleVisibility }): SimpleInterpolation => (toggleVisibility && css`
      position: absolute;
      right: 0;
      top: 0;
    `
  )}
  }
`

type Props = {
  duration?: number,
  trashStatus?: TrashStatus,
  pendingStatus?: TrashStatus,
  toggleVisibility?: boolean,
}

const RowDuration = ({
  duration = 0,
  pendingStatus,
  toggleVisibility = false,
}: Props): React.ReactElement<Props> => (
  <DurationLabel
    className={`${toggleVisibility ? ROW_DURATION_VISIBILITY_CLASSNAME : ""}`}
    pendingStatus={pendingStatus}
    toggleVisibility={toggleVisibility}
  >
    {getDurationStr(duration)}
  </DurationLabel>
)

export default RowDuration
